import type { ReportConfigCombinations } from 'src/types/reportConfig';

export const DEFAULT_REPORT_CONFIG_COMBINATIONS: ReportConfigCombinations['content'] =
  {
    descriptions: {},
    fileTypes: {},
    languages: {},
    reportTypes: {},
  };
Object.freeze(DEFAULT_REPORT_CONFIG_COMBINATIONS);
